<template>

    <header>

        <div class="container">

            <div class="row flex-nowrap justify-content-between">

                <!-- BRANDING -->
                <div class="branding">
                    <div class="logo">
                        <router-link :to="branding.link.url" :title="branding.link.title">
                            <animated-logo v-if="showLogo"></animated-logo>
                        </router-link>
                    </div>
                    <div class="flap"></div>
                </div>
                <!-- END BRANDING -->

                <!-- NAVIGATION -->
                <div class="navigation">
                    <a href="javascript:void(0);" @click="toggleMenu" class="nav-toggle d-block d-md-none">
                        <img v-if="!menuState" src="/static/images/ui/icon-menu@1x.png" srcset="/static/images/ui/icon-menu@1x.png 1x, /static/images/ui/icon-menu@2x.png 2x, /static/images/ui/icon-menu@3x.png 3x" alt="" />
                        <img v-if="menuState" class="" src="/static/images/ui/icon-close@1x.png" srcset="/static/images/ui/icon-close@1x.png 1x, /static/images/ui/icon-close@2x.png 2x, /static/images/ui/icon-close@3x.png 3x" alt="" />
                    </a>
                    <nav class="d-none d-md-block">
                        <ul>
                            <li v-for="(section, $index) in enabledSections" :key="$index">
                                <router-link :to="section.path" @click.native="scrollToSection(section.anchor)" v-html="section.label" active-class="active" exact></router-link>
                                <div class="flap"></div>
                            </li>
                        </ul>
                    </nav>
                </div>
                <!-- END NAVIGATION -->

            </div>

            <div class="row d-block d-md-none">
                <div class="navigation mobile">
                    <nav>
                        <ul>
                            <li v-for="(section, $index) in enabledSections" :key="$index">
                                <router-link :to="section.path" @click.native="scrollToSection(section.anchor)" v-html="section.label" active-class="active" exact></router-link>
                                <div class="flap"></div>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>

        </div>

    </header>

</template>


<script>

    import _ from 'lodash';
    import AOS from 'aos';
    import VueScrollTo from 'vue-scrollto';
    import AnimatedLogo from "./AnimatedLogo";
    // eslint-disable-next-line
    import waypoint from "waypoints/lib/noframework.waypoints.min.js";

    let vm = {};

    export default {

        name: 'AppHeader',

        components: {
            AnimatedLogo
        },

        data() {
            return {
                appTitle: 'Stupendo.us',
                branding: {
                    logo: {
                        image: {
                            x1: '/static/images/branding/logo@1x.png',
                            x2: '/static/images/branding/logo@2x.png',
                            x3: '/static/images/branding/logo@3x.png'
                        },
                        altText: 'Stupendo.us'
                    },
                    link: {
                        url: '/',
                        title: 'Stupendo.us'
                    }
                },
                sections: [
                    {
                        path: '/',
                        label: 'Demo!',
                        enabled: true,
                        anchor: '#app'
                    }, {
                        path: '/about',
                        label: 'About!',
                        enabled: true,
                        anchor: '#about'
                    }, {
                        path: '/contact',
                        label: 'Contact!',
                        enabled: true,
                        anchor: '#contact'
                    }
                ],
                menuState: false,
                showLogo: false,
            }
        },

        computed: {

            getLogoSrcset() {
                return this.branding.logo.image.x1 + ' 1x, ' + this.branding.logo.image.x2 + ' 2x, ' + this.branding.logo.image.x3 + ' 3x, ';
            },

            enabledSections() {
                return _.filter(this.sections, (section) => {
                    return section.enabled === true;
                });
            }

        },

        created() {

        },

        mounted() {

            vm = this;

            AOS.refreshHard();

            this.initWaypoint();
        },

        methods: {

            /**
             * @method scrollToSection
             * @description
             * @param {String} anchor
             */
            scrollToSection(anchor) {
                VueScrollTo.scrollTo(anchor, 600, {
                    onDone: function() {
                        if (anchor === '#app') {
                            vm.$eventBus.$emit('video::replay', null);
                        }
                    }
                });
            },
            //Watch for scolling past video
            initWaypoint() {

                //window width
                let _clWidth = document.documentElement.clientWidth,
                    _el = document.querySelector('#hero');

                //if user closed the menu at a smaller screen, reopen menu,
                //logo, and flaps when toggle option goes away at a larger screen
                window.addEventListener('resize', function() {
                    if ((_clWidth > 768) && (!vm.menuState)) {
                        vm.toggleMenu();
                    }
                });

                // eslint-disable-next-line
                let waypoint1 = new Waypoint({
                    element: document.getElementById('about'),
                    handler: function(direction) {
                        //if scrolled past video
                        if ((direction === "down") && (!vm.menuState)) {
                            //show header
                            vm.toggleMenu();
                        //if scrolled back up to video
                        } else if ((direction === "up") && (vm.menuState)) {
                          //hide header
                          vm.toggleMenu();
                        }
                    },
                    //trigger when top of the about element is 40% of the way from
                    //the top of the window
                    offset: function(){
                        return _el.clientHeight * 0.4;
                    }
                });

            },

            toggleMenu() {
                let _header = document.querySelector('header');
                let _flaps  = document.querySelectorAll('.flap');
                let _logo   = document.querySelector('.logo');

                if (vm.menuState) {
                    _logo.classList.remove('show');
                    vm.showLogo = false;
                    _flaps.forEach(function(el) {
                        _header.classList.remove('show');
                        el.classList.remove('show');
                        vm.menuState = false;
                    });
                } else {
                    _logo.classList.add('show');
                    vm.showLogo = true;
                    _flaps.forEach(function(el) {
                        _header.classList.add('show');
                        el.classList.add('show');
                        vm.menuState = true;
                    });
                }
            }
        }
    }

</script>


<style lang="scss" scoped>

    $text-shadow-color: rgba(50,152,190, 1);
    $text-shadow-color-active: rgba(184, 85, 157, 1);

    header {
        width: 100%;
        padding: 20px 0;
        margin: 0 0 0 0;
        overflow: hidden;
        position: fixed;
        z-index: 999;
        transition: all 0.3s $easeInOutQuad;
        pointer-events: none;

        @media (min-width: 576px) { // RED

        }

        @media (min-width: 768px) { // GREEN

            transition: all 0.3s $easeInOutQuad;
        }

        @media (min-width: 992px) { // BLUE
            padding: 20px 20px;
            transition: all 0.3s $easeInOutQuad;
        }

        @media (min-width: 1200px) { // YELLOW
            padding: 40px 50px;
            transition: all 0.3s $easeInOutQuad;
        }

        &::after {
            content: '';
            background: radial-gradient(ellipse at top, rgba(63,62,138,0.70) 0%,rgba(63,62,138,0) 70%);
            //background: linear-gradient(to bottom, rgba(63,62,138,0.54) 0%, rgba(63,62,138,0) 100%);
            width: 100%;
            height: 100%;
            display: block;
            opacity: 0;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            transform: translateY(-150px);
            transition: all 0.3s $easeInOutQuad;
            pointer-events: none;
        }

        &.show {

            &::after {
                opacity: 1;
                transform: translateY(0);
                transition: all 0.3s $easeInOutQuad;
            }

            .navigation {

                &.mobile {

                    & nav {
                        display: block;
                    }
                }
            }
        }

        & > .container {
            position: relative;
            z-index: 3;
        }
    }

    .branding {
        margin: -30px 0 0 -10px;
        padding: 0 0 0 0;
        position: relative;
        transition: all 0.3s $easeInOutQuad;

        @media (min-width: 576px) { // RED

        }

        @media (min-width: 768px) { // GREEN
            margin: -40px 0 0 -40px;
            transition: all 0.3s $easeInOutQuad;
        }

        @media (min-width: 992px) { // BLUE
            margin: -40px 0 0 0;
            transition: all 0.3s $easeInOutQuad;
        }

        @media (min-width: 1200px) { // YELLOW
            margin: -50px 0 0 0;
            transition: all 0.3s $easeInOutQuad;
        }

        & .flap {
            content: '';
            background: linear-gradient(to right, rgba(100,99,172,1) 0%,rgba(63,62,138,1) 100%);
            width: 100vw;
            height: 100%;
            max-height: 110px;
            box-shadow: 5px 5px 0 rgba(64,62,139, 0.35);
            position: absolute;
            right: 40px;
            bottom: 40%;
            z-index: 1;
            transform-origin: 100% 50%;
            transform: skew(-40deg) rotate(5deg) translateY(50%) translateX(-100%);
            transition: all 0.3s $easeInOutQuad;
            pointer-events: none;
            will-change: transform;

            @media (min-width: 576px) { // RED

            }

            @media (min-width: 768px) { // GREEN

            }

            @media (min-width: 992px) { // BLUE
                right: -40px;
                bottom: 40%;
            }

            @media (min-width: 1200px) { // YELLOW

            }

            &.show {
                transform: skew(-40deg) rotate(5deg) translateY(50%) translateX(0);
                transition: all 0.3s $easeInOutQuad;
            }
        }
    }

    .logo {
        line-height: 0;
        width: 60%;
        position: relative;
        z-index: 5;
        opacity: 0;
        will-change: transform;

        @media (min-width: 576px) { // RED

        }

        @media (min-width: 768px) { // GREEN
            width: 80%;
            transition: all 0.3s $easeInOutQuad;
        }

        @media (min-width: 992px) { // BLUE
            width: 100%;
            transition: all 0.3s $easeInOutQuad;
        }

        @media (min-width: 1200px) { // YELLOW

        }

        & a {
            display: block;
            backface-visibility: hidden;
            user-select: none;
            pointer-events: auto;

            &:hover {
                animation: tada 1s;
            }
        }

        & img {
            transition: all 0.3s ease;
        }
        &.show{
          opacity: 1;
          transition: all 1s $easeInOutQuad;
        }
    }

    .navigation {

        &.mobile {
            margin-top: -13px;

            & nav {
                display: none;

                & .flap {
                    width: 100vw;
                    height: 30px;
                    min-height: 30px;
                    max-height: 110px;
                    left: 8px;
                    bottom: 30%;
                    transform: skew(-40deg) rotate(-5deg) translateY(50%) translateX(100vw);
                    transition: all 0.3s $easeInOutQuad;

                    &.show {
                        transform: skew(-40deg) rotate(-5deg) translateY(50%) translateX(0);
                        transition: all 0.3s $easeInOutQuad;
                    }
                }
            }
        }

        & .nav-toggle {
            width: 28px;
            height: 28px;
            margin: -13px 13px 0 0;
            display: block;
            pointer-events: auto;

            & img {
                max-width: 100%;
                height: auto;
            }
        }
    }

    nav {

        & ul {
            list-style-type: none;
            margin: 0 0 0 0;
            padding: 0 0 0 0;
            position: relative;

            & > li {
                margin: 0 0 0 0;
                padding: 0 0 0 0;
                display: inline-block;
                position: relative;
                backface-visibility: hidden;

                &:nth-of-type(1) {
                    z-index: 1;

                    & .flap {
                        background: linear-gradient(to bottom, rgba(68,160,199,1) 0%, rgba(38,122,172,1) 100%);
                        transition-delay: 0.12s;

                        &.show {
                            transition-delay: 0.16s;
                        }
                    }
                }

                &:nth-of-type(2) {
                    z-index: 2;

                    & .flap {
                        background: linear-gradient(to bottom, rgba(157,48,138,1) 0%, rgba(186,83,171,1) 100%);
                        transition-delay: 0.06s;

                        &.show {
                            transition-delay: 0.08s;
                        }
                    }
                }

                &:nth-of-type(3) {
                    z-index: 3;

                    & .flap {
                        background: linear-gradient(to bottom, rgba(92,91,165,1) 0%, rgba(64,64,140,1) 100%);

                        &.show {
                            transition-delay: 0.0s;
                        }
                    }
                }

                & .flap {
                    content: '';
                    background: linear-gradient(to right, rgba(100,99,172,1) 0%,rgba(63,62,138,1) 100%);
                    width: 50vw;
                    height: 100%;
                    min-height: 55px;
                    max-height: 110px;
                    box-shadow: 5px 5px 0 rgba(64,62,139, 0.35);
                    position: absolute;
                    left: 8px;
                    bottom: 30%;
                    z-index: 1;
                    transform-origin: 0% 50%;
                    transform: skew(-40deg) rotate(-5deg) translateY(50%) translateX(100%);
                    transition: all 0.3s $easeInOutQuad;
                    will-change: transform;

                    &.show {
                        transform: skew(-40deg) rotate(-5deg) translateY(50%) translateX(0);
                        transition: all 0.3s $easeInOutQuad;
                    }
                }

                & ~ li {

                    & a {

                        &::before {
                            background-color: transparent;
                        }
                    }
                }

                & a {
                    font-family: $font-coconpro-bolditalic;
                    font-size: 1.25rem;
                    line-height: 1;
                    letter-spacing: -1px;
                    text-decoration: none;
                    text-transform: none;
                    text-shadow:
                            -1px -1px $text-shadow-color,
                            -1px 1px $text-shadow-color,
                            0 1px $text-shadow-color,
                            0 2px $text-shadow-color,
                            0 3px $text-shadow-color,
                            1px -1px $text-shadow-color,
                            1px 2px $text-shadow-color,
                            1px 3px $text-shadow-color,
                            1px 4px $text-shadow-color,
                            2px 5px 1px $text-shadow-color,
                            2px -1px $text-shadow-color,
                            1px 1px $text-shadow-color,
                            1px 1px 1px $text-shadow-color,
                            2px 2px $text-shadow-color,
                            3px 3px $text-shadow-color,
                            4px 4px 1px $text-shadow-color;
                    color: rgba(255,255,255, 1.0);
                    padding: 0 1.5rem 0 1.0rem;
                    display: inline-block;
                    position: relative;
                    z-index: 5;
                    user-select: none;
                    backface-visibility: hidden;
                    -webkit-font-smoothing: subpixel-antialiased;
                    transition: all 0.3s ease-in-out;
                    transform: rotate(-5deg) scale(1);
                    pointer-events: auto;
                    will-change: transform;

                    @media (min-width: 576px) { // RED

                    }

                    @media (min-width: 768px) { // GREEN

                    }

                    @media (min-width: 992px) { // BLUE
                        font-size: 1.875rem;
                        padding: 0 2.0rem 0 1.0rem;
                        transition: all 0.3s ease-in-out;
                    }

                    @media (min-width: 1200px) { // YELLOW

                    }

                    &::before,
                    &::after {
                        content: '';
                        width: 1px;
                        height: 100%;
                        position: absolute;
                        top: 0;
                        transition: all 0.3s ease-in-out;
                    }

                    &::before {
                        left: 0;
                    }

                    &::after {
                        right: 0;
                    }

                    @media (hover:hover) {
                        &:hover {
                            //animation: rubberBand 1s;
                            transform: rotate(-5deg) scale(1.12);
                            transition: all 0.3s $easeInOutCirc;

                            &::before,
                            &::after {
                                transition: all 0.4s ease-in-out;
                            }
                        }
                    }

                    &.active {
                        text-shadow:
                                -1px -1px $text-shadow-color-active,
                                -1px 1px $text-shadow-color-active,
                                0 1px $text-shadow-color-active,
                                0 2px $text-shadow-color-active,
                                0 3px $text-shadow-color-active,
                                1px 2px $text-shadow-color-active,
                                1px 3px $text-shadow-color-active,
                                1px 4px $text-shadow-color-active,
                                2px 5px 1px $text-shadow-color-active,
                                1px 1px $text-shadow-color-active,
                                1px 1px 1px $text-shadow-color-active,
                                2px 2px $text-shadow-color-active,
                                3px 3px $text-shadow-color-active,
                                4px 4px 1px $text-shadow-color-active;
                        transform: rotate(-5deg) scale(1.12);
                        transition: all 0.4s ease-in-out;

                        &::before,
                        &::after {
                            transition: all 0.4s ease-in-out;
                        }

                        @media (hover:hover) {
                            &:hover {
                                animation: none;
                            }
                        }

                    }
                }
            }
        }
    }

</style>
